import baseStore from '../baseStore';

import images from './data';

let thumbnailSize = 150;
let rows = [];
const maxNrImages = 500;

const storage = Object.assign(baseStore, {
  // need to get images, convert them into rows, and then get data. Also,
  // need to figure out when to load new data. Start out with just static
  // sample data

  getImages: () => {
    return images;
  },

  getMaxNrImages: () => {
    return maxNrImages;
  },

  setRows: (rowData) => {
    rows = rowData;
    storage.emitChange();
  },

  getRow: (nr) => {
    if (nr >= rows.length) {
      return [];
    }

    if (!rows[nr]) {
      return [];
    }
    return rows[nr];
  },

  getNrRows() {
    return rows.length;
  },

  getThumbnailSize() {
    return thumbnailSize;
  },

  setThumbnailSize(value) {
    if (thumbnailSize !== value) {
      thumbnailSize = value;
    }
    storage.emitChange();
  },
});

export default storage;
